Devuelve usuarios de la organización que pueden referenciarse como destinos de transferencia en la API pública.

Los usuarios inactivos también aparecen para que sistemas externos reconcilien ids y disponibilidad operativa sin perder referencias históricas.

<ApiCodeExamples exampleId="usersList" />

<ApiResponseExamples exampleId="usersList" />

## Alcance obligatorio

- `users.read`

## Endpoints

- `GET /public/v1/users/`: lista paginada.
- `GET /public/v1/users/{id}/`: detalle de un usuario.

El detalle usa el mismo formato de campos del item de lista.

## Query parameters

- `page` (`integer`, opcional): número de página.
- `page_size` (`integer`, opcional): cantidad de items por página. Default `25`, máximo `100`.
- `search` (`string`, opcional): busca por nombre, apellido y email.
- `ordering` (`string`, opcional): `email`, `first_name`, `last_name`, `last_login`, `telephony_availability_updated_at`, o los mismos campos con prefijo `-`.
- `transfer_eligible` (`boolean`, opcional): `true` para usuarios activos con endpoint elegible, `false` para usuarios que no pueden recibir transferencia ahora.

## Campos de respuesta

- `id` (`uuid`): id público del usuario para `transfer_target.id`.
- `name` (`string`): nombre visible.
- `email` (`string`): email del usuario.
- `is_active` (`boolean`): indica si la cuenta está activa.
- `transfer_eligible` (`boolean`): indica si el usuario puede usarse como destino de transferencia ahora.
- `telephony_endpoint` (`object|null`): endpoint activo y elegible seleccionado para exhibición.
- `telephony_endpoint.id` (`uuid`): id público del endpoint.
- `telephony_endpoint.endpoint_type` (`string`): tipo del endpoint.
- `telephony_endpoint.extension` (`string|null`): extensión interna, si existe.
- `telephony_endpoint.external_phone_e164` (`string|null`): teléfono externo, si existe.
- `last_login_at` (`datetime|null`): último login del usuario.
- `updated_at` (`datetime|null`): última actualización de disponibilidad telefónica usada por este catálogo.

## Referencia de opciones

- `telephony_endpoint.endpoint_type`: `internal_extension` o `external_extension`.
- `transfer_eligible=true` exige usuario activo y endpoint de transferencia activo/elegible.

## Errores esperados

- `401 Unauthorized`: token inválido, expirado, revocado, ausente o bloqueado por IP.
- `403 Forbidden`: la credencial no tiene `users.read`.
- `404 Not Found`: el id del detalle no está disponible para la organización.
- `429 Too Many Requests`: rate limit de la credencial excedido.
